import React from 'react';
import { COLORS, SPACING } from '../../constants/theme';

/**
 * LoadingSpinner Component
 * Consistent loading indicator used across the app
 *
 * @param {string} message - Optional loading message (default: "Loading...")
 * @param {boolean} fullPage - Whether to show as full-page loader (default: true)
 */
const LoadingSpinner = ({ message = 'Loading...', fullPage = true }) => {
  const styles = {
    container: fullPage
      ? {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: COLORS.background.default,
        }
      : {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: SPACING.xxxl,
        },
    content: {
      textAlign: 'center',
    },
    spinner: {
      border: `4px solid ${COLORS.gray[200]}`,
      borderTop: `4px solid ${COLORS.primary}`,
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      animation: 'spin 1s linear infinite',
      margin: '0 auto',
      marginBottom: SPACING.lg,
    },
    message: {
      color: COLORS.gray[600],
      fontSize: '16px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.spinner} />
        <div style={styles.message}>{message}</div>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
